import React from 'react';
import PropTypes from 'prop-types';
import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import AppColor from "../../../../utilities/AppColor";
import AppUtil from "../../../../utilities/AppUtil";

const useStyles = makeStyles(() => ({
    flex: {
        display: 'flex',
        alignItems: 'center'
    },
    boxLeft: {
        backgroundColor: AppColor.mainColor,
        borderBottomLeftRadius: '6px',
        borderTopLeftRadius: '6px',
        width: '100%',
        padding: '8px',
        color: AppColor.white,
        fontWeight: 'bold',
        textAlign: 'center'
    },
    boxCenter: {
        backgroundColor: AppColor.mainColor,
        width: '100%',
        padding: '8px',
        color: AppColor.white,
        fontWeight: 'bold',
        textAlign: 'center',
        margin: '0px 3px'
    },
    boxRight: {
        backgroundColor: AppColor.mainColor,
        borderTopRightRadius: '6px',
        borderBottomRightRadius: '6px',
        width: '100%',
        padding: '8px',
        color: AppColor.white,
        fontWeight: 'bold',
        textAlign: 'center'
    },
    childBoxLeft: {
        border: '1px solid rgba(0, 0, 0, 0.2)',
        width: '100%',
        padding: '8px',
        textAlign: 'center',
        color: AppColor.black
    },
    childBoxCenter: {
        border: '1px solid rgba(0, 0, 0, 0.2)',
        width: '100%',
        padding: '8px',
        fontWeight: '500',
        textAlign: 'right',
        margin: '0px 3px',
        color: AppColor.black
    },
    childBoxRight: {
        border: '1px solid rgba(0, 0, 0, 0.2)',
        width: '100%',
        padding: '8px',
        fontWeight: '500',
        textAlign: 'right',
        color: AppColor.black
    }
}))

const SegmentPayrollTable = props => {
    const {
        data
    } = props;
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Box mt={1}>
            <Box className={classes.flex}>
                <Box className={classes.boxLeft}>
                    {t('label.shift')}
                </Box>
                <Box className={classes.boxCenter}>
                    {t('label.hours')}
                </Box>
                <Box className={classes.boxRight}>
                    {t('label.price')}
                </Box>
            </Box>
            <Box style={{ marginTop: '3px' }}>
                {data.map((item, index) => (
                    <Box key={index} className={classes.flex}>
                        <Box className={classes.childBoxLeft} style={{
                            ...index === 0 && {
                                borderTopLeftRadius: '6px',
                            },
                            ...index === data.length - 1 && {
                                borderBottomLeftRadius: '6px',
                            },
                            ...index > 0 && {
                                borderTopWidth: 0
                            }
                        }}>
                            {t(`shift.${item.shiftType}`)}
                        </Box>
                        <Box className={classes.childBoxCenter} style={{
                            ...index > 0 && {
                                borderTopWidth: 0
                            }
                        }}>
                            {AppUtil.formatMoney(item.totalHours)}
                        </Box>
                        <Box className={classes.childBoxRight} style={{
                            ...index === 0 && {
                                borderTopRightRadius: '6px',
                            },
                            ...index === data.length - 1 && {
                                borderBottomRightRadius: '6px',
                            },
                            ...index > 0 && {
                                borderTopWidth: 0
                            }
                        }}>
                            ${AppUtil.formatMoney(item.totalPrice)}
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    )
}

SegmentPayrollTable.propTypes = {
    data: PropTypes.array
}

SegmentPayrollTable.defaultProps = {
    data: []
}

export default SegmentPayrollTable;
